import { render } from "./QADetail.vue?vue&type=template&id=43ed8be9&scoped=true"
import script from "./QADetail.vue?vue&type=script&lang=js"
export * from "./QADetail.vue?vue&type=script&lang=js"

import "./QADetail.vue?vue&type=style&index=0&id=43ed8be9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ed8be9"]])

export default __exports__